import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GetActivityLogsState {
    logs: any[];
    count: number;
    isLoading: boolean;
    error: string | null;
}

interface SetActivityLogsPayload {
    logs: any[];
    count?: number;
}

const initialState: GetActivityLogsState = {
    logs: [],
    count: 0,
    isLoading: false,
    error: null,
};

const getActivityLogsSlice = createSlice({
    name: "getActivityLogs",
    initialState,
    reducers: {
        setActivityLogsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        setActivityLogs: (state, action: PayloadAction<any[] | SetActivityLogsPayload>) => {
            const payload = action.payload;
            if (Array.isArray(payload)) {
                state.logs = payload ?? [];
                state.count = 0;
            } else {
                state.logs = payload?.logs ?? [];
                state.count = payload?.count ?? 0;
            }
            state.isLoading = false;
            state.error = null;
        },
        setActivityLogsError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
            state.isLoading = false;
            state.logs = [];
            state.count = 0;
        },
        resetActivityLogs: () => initialState,
    },
});

export const {
    setActivityLogsLoading,
    setActivityLogs,
    setActivityLogsError,
    resetActivityLogs,
} = getActivityLogsSlice.actions;

export default getActivityLogsSlice.reducer;
